import { gql, type TypedDocumentNode } from '@apollo/client';
import type { ProgramTypeEnum } from '@rivallapp/volosports-components';

type ProgramDetails = {
  league: {
    _id: string;
    gender: string;
    header?: string | null;
    formatType?: string | null;
    displayName: string;
    programType: ProgramTypeEnum;
    banner_text?: string | null;
    price_phase?: string | null;
    hasDivisions: boolean;
    divisionDescriptions?: string[] | null;
    num_weeks_estimate: number;
    start_date?: Date | null;
    end_time_estimate: string;
    start_time_estimate: string;
    is_volo_pass_exclusive: boolean;
    is_premier: boolean;
    details: {
      features?: string[] | null;
    };
    venue: {
      _id: string;
      name: string;
      location: {
        lat?: number | null;
        lng?: number | null;
      };
    };
    schedules: {
      num_weeks: number;
      start_date: Date;
      endTimeStr: string;
      startTimeStr: string;
    }[];
    registration: {
      _id: string;
      phases: {
        earlyBird: {
          endDateStr: string;
          individualPrice: number;
          prepaidTeamPrice: number;
        };
        regular: {
          endDateStr: string;
          individualPrice: number;
          prepaidTeamPrice: number;
        };
        lastChance: {
          endDateStr: string;
          individualPrice: number;
          prepaidTeamPrice: number;
        };
      };
    };
  };
};

const PROGRAM_DETAILS: TypedDocumentNode<ProgramDetails, { id: string }> = gql`
  query League($id: ID!) {
    league(_id: $id) {
      _id
      gender
      header
      formatType
      displayName
      programType
      banner_text
      price_phase
      hasDivisions
      divisionDescriptions
      num_weeks_estimate
      start_date
      end_time_estimate
      start_time_estimate
      is_volo_pass_exclusive
      is_premier
      details {
        features
      }
      venue {
        _id
        name
        location {
          lat
          lng
        }
      }
      schedules {
        _id
        num_weeks
        start_date
        endTimeStr
        startTimeStr
      }
      registration {
        _id
        phases {
          earlyBird {
            endDateStr
            individualPrice
            prepaidTeamPrice
            individualPriceWithFees
          }
          regular {
            endDateStr
            individualPrice
            prepaidTeamPrice
            individualPriceWithFees
          }
          lastChance {
            endDateStr
            individualPrice
            prepaidTeamPrice
          }
        }
      }
    }
  }
`;

export default PROGRAM_DETAILS;
